import config from '../misc/Configuracao';
import fetch from './AxiosAdapter';

class IndicadoresApi {

    //TODO retirar as any
    async recuperarTodos() {
        const result = await fetch(config.urlPrioridades);
        const prioridades = result.data as any;
        return prioridades;
    }
}

export default new IndicadoresApi();